//
// UnicodeFacility.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "./PortableCollator";
import "./PortableBidi";
import "./TextDirection";
import "./CharDirection";

var UnicodeFacility = createModule("commons_UnicodeFacility", [166], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        isICUBIDIProcessingEnabled: [2],
        _getBidi_v: [1],
        hasRTL: [2,7],
        getCollator: [1,7],
        getAnalysisLevel: [4,4,7],
        needDirection: [2,4,7],
        getBaseDirection: [4,7],
        getCharDirection: [4,4],
        isWeak: [2,7],
        _getBidi_sn: [1,7,4],
        _getBidi_snnb: [1,7,4,4,2],
        isICUEnabled: [2],
    },
    {
        _create: [4],
    },
    ["getBidi"],
]);
export default UnicodeFacility;
